module.exports = __webpack_public_path__ + "static/img/icon_zhijian.2ad58d62.png";